import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';

import styles from './Modal.module.scss';
import CorporateInquiry from '@common/components/Forms/CorporateInquiry/CorporateInquiry';
import ContactSales from '@common/components/Forms/ContactSales/ContactSales';
import WaitListForm from '@common/components/Forms/WaitList/WaitList';
import MediaNewsletter from '@common/components/Forms/MediaNewsletter/MediaNewsletter';
import AppointmentRequest from '@common/components/Forms/AppointmentRequest/AppointmentRequest';
import Newsletter from '@common/components/Forms/Newsletter/Newsletter';
import {useDispatch, useSelector} from "react-redux";
import {AnimatePresence} from "framer-motion";
import {hideModal} from "@store/appStateSlice";
import ContactUsForm from "@components/Modals/ContactUsForm";
import ViewDetails from "@components/Modals/ViewDetails";
import PaymentSuccess from "@components/Modals/PaymentSuccess";
import PaymentError from "@components/Modals/PaymentError";

const Modal = () => {
  const dispatch = useDispatch();
  const { showModal, modalProps, direction } = useSelector(
    ({ appState }) => appState
  );
  const { modalName, modalProps: rest } = modalProps;

  const handleClose = () => {
    dispatch(hideModal());
  };

  return (
    <AnimatePresence>
      {showModal && (
        <div className={styles.modalWrap} dir={direction}>
          <motion.div
            key="modal-overlay"
            className={styles.modalOverlay}
            onClick={handleClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.25, duration: 0.75 }}
          />
          <motion.div
            key="modal"
            className={styles.modalContainer}
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -40, opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <section className={styles.modalContainerContent}>
              <>
                { modalName === 'CONTACT' ? (
                  <ContactUsForm {...rest} />
                ) : modalName === 'VIEW_DETAILS' ? (
                  <ViewDetails {...rest} />
                ) : modalName === 'PAYMENT_SUCCESS' ? (
                  <PaymentSuccess {...rest} />
                ) : modalName === 'PAYMENT_ERROR' ? (
                  <PaymentError {...rest} />
                ) : (
                  ''
                )}
              </>
            </section>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
